import * as CubeTree from '../../../cubeTree/index';

/**
 * 查找优先级
 *
 * 1. 货架
 * 2. 画布中的层板
 * 3. 画布
 */
function partitionTarget(allSelected: Array<CubeId>): Array<CubeId> {
    let result: Set<CubeId> = new Set();

    // 货架
    allSelected.forEach((target: CubeId): void => {
        if (CubeTree.isShelf(target) || CubeTree.isFreezer(target)) {
            result.add(target);
            return;
        }

        if (CubeTree.isPartition(target)
            || CubeTree.isGoods(target)
            || CubeTree.isBafflePlate(target)
            || CubeTree.isTextarea(target)) {
            let shelfId: CubeId|null = CubeTree.findCubeShelf(target);

            shelfId && result.add(shelfId);
        }
    });

    // 画布中的层板
    allSelected.forEach((target: CubeId): void => {
        if (CubeTree.isPartition(target) && CubeTree.isInStage(target)) {
            result.add(target);
        }
    });

    if (!result.size) {
        result.add(CubeTree.findSketchpad());
    }

    return Array.from(result);
}

export {
    partitionTarget
};
